import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
import Cookies from 'js-cookie'
let state =  require('../store/index').default.state
import _this from '../main.js'

// let newApj = 'http://47.108.63.102'// 测式环境
let newApj = 'https://api.shangyikj.cn'// 正式环境

class BaseModule {
  managerAdminLogin (data) {//用户登录
		return this.postFn(newApj + '/api/manager/admin/login', data)
  }
  managerAdminProfile (data) {//基本信息
		return this.getFn(newApj + '/api/manager/admin/profile', data)
  }
  managerAdminPasswordEdit (data) {//修改密码
		return this.postFn(newApj + '/api/manager/admin/password/edit', data)
  }
  managerAdminLogout (data) {//登出
		return this.postFn(newApj + '/api/manager/admin/logout', data)
  }
  managerCouponList (data) {//列表查询(优惠券)
		return this.getFn(newApj + '/api/manager/coupon/list', data)
  }
  managerCouponSave (data) {//新增修改(优惠券)
		return this.postFn(newApj + '/api/manager/coupon/save', data)
  }
  managerCouponStatus (data) {//启用禁用(优惠券)
		return this.postFn(newApj + '/api/manager/coupon/status', data)
  }
  managerCouponDelete (data) {//删除(优惠券)
		return this.postFn(newApj + '/api/manager/coupon/delete', data)
  }
  wxReserveQuestionList (data) {//列表查询(预约问题设置)
		return this.getFn(newApj + '/api/manager/wx/reserve/question/list', data)
  }
  managerWxReserveQuestionSave (data) {//新增修改(预约问题设置)
		return this.postFn(newApj + '/api/manager/wx/reserve/question/save', data)
  }
  managerWxReserveQuestionStatus (data) {//启用禁用(预约问题设置)
		return this.postFn(newApj + '/api/manager/wx/reserve/question/status', data)
  }
  managerWxReserveQuestionDelete (data) {//删除(预约问题设置)
		return this.postFn(newApj + '/api/manager/wx/reserve/question/delete', data)
  }
  managerCouponSend (data) {//赠送优惠券(优惠券)
		return this.postFn(newApj + '/api/manager/coupon/send', data)
  }
  managerCouponAvailable (data) {//下拉列表(优惠券)
		return this.getFn(newApj + '/api/manager/coupon/list/available', data)
  }
  managerCouponReceiveList (data) {//优惠券领取-列表查询
		return this.getFn(newApj + '/api/manager/coupon/receive/list', data)
  }
  managerCouponReceiveSave (data) {//优惠券领取-新增修改
		return this.postFn(newApj + '/api/manager/coupon/receive/save', data)
  }
  managerCouponReceiveStatus (data) {//优惠券领取-启用禁用
		return this.postFn(newApj + '/api/manager/coupon/receive/status', data)
  }
  managerCouponReceiveDelete (data) {//优惠券领取-删除
		return this.postFn(newApj + '/api/manager/coupon/receive/delete', data)
  }
  managerGoodsListAvailable1 (data) {//商品列表查询(适用范围：采购订单、采购入库单、零售退货入库单、库存盘盈单、库存盘亏单、优惠券)
		return this.getFn(newApj + '/api/manager/goods/list/available1', data)
  }
  managerGoodsListAvailable2 (data) {//商品列表查询(采购退货出库单、零售出库单、外部调拨单、内部转仓单)
		return this.getFn(newApj + '/api/manager/goods/list/available2', data)
  }
  managerBrandList (data) {//列表查询(品牌管理)
		return this.getFn(newApj + '/api/manager/brand/list', data)
  }
  managerBrandSave (data) {//新增修改(品牌管理)
		return this.postFn(newApj + '/api/manager/brand/save', data)
  }
  managerBrandStatus (data) {//启用禁用(品牌管理)
		return this.postFn(newApj + '/api/manager/brand/status', data)
  }
  managerBrandDelete (data) {//删除(品牌管理)
		return this.postFn(newApj + '/api/manager/brand/delete', data)
  }
  managerBrandListAvailable (data) {//下拉列表(品牌管理)
		return this.getFn(newApj + '/api/manager/brand/list/available', data)
  }
  managerStockList (data) {//列表查询(库存查询)
		return this.getFn(newApj + '/api/manager/stock/list', data)
  }
  managerReserveStoreList (data) {//列表查询(门店管理)
		return this.getFn(newApj + '/api/manager/store/list', data)
  }
  managerReserveStoreDetail (data) {//详情(门店管理)
		return this.getFn(newApj + '/api/manager/store/detail', data)
  }
  managerReserveStoreSave (data) {//新增修改(门店管理)
		return this.postFn(newApj + '/api/manager/store/save', data)
  }
  managerReserveStoreStatus (data) {//启用禁用(门店管理)
		return this.postFn(newApj + '/api/manager/store/status', data)
  }
  managerReserveStoreDelete (data) {//删除(门店管理)
		return this.postFn(newApj + '/api/manager/store/delete', data)
  }
  managerReserveStoreListAvailable (data) {//下拉列表(门店管理)
		return this.getFn(newApj + '/api/manager/store/list/available', data)
  }
  managerReserveStoreListPermission (data) {//下拉列表(有权限的)(门店管理)
		return this.getFn(newApj + '/api/manager/store/list/permission', data)
  }
  managerStoreHouseList (data) {//列表查询(仓库管理)
		return this.getFn(newApj + '/api/manager/store/house/list', data)
  }
  managerStoreHouseSave (data) {//新增修改(仓库管理)
		return this.postFn(newApj + '/api/manager/store/house/save', data)
  }
  managerStoreHouseStatus (data) {//启用禁用(仓库管理)
		return this.postFn(newApj + '/api/manager/store/house/status', data)
  }
  managerStoreHouseDelete (data) {//删除(仓库管理)
		return this.postFn(newApj + '/api/manager/store/house/delete', data)
  }
  managerStoreHouseListByStore (data) {//下拉列表(仓库管理)
		return this.getFn(newApj + '/api/manager/store/house/list/by/store', data)
  }
  managerStoreHouseListByStoreSale (data) {//下拉列表-销售库(仓库管理)
		return this.getFn(newApj + '/api/manager/store/house/list/by/store/sale', data)
  }
  managerStoreHouseListAll (data) {//所有可用仓库(仓库管理)
		return this.getFn(newApj + '/api/manager/store/house/list/all', data)
  }
  managerCategoryTree (data) {//分类树(商品分类)
		return this.getFn(newApj + '/api/manager/category/tree', data)
  }
  managerCategoryFirstSave (data) {//一级分类新增修改(商品分类)
		return this.postFn(newApj + '/api/manager/category/first/save', data)
  }
  managerCategorySecondSave (data) {//二级分类新增修改(商品分类)
		return this.postFn(newApj + '/api/manager/category/second/save', data)
  }
  managerCategoryDelete (data) {//删除(商品分类)
		return this.postFn(newApj + '/api/manager/category/delete', data)
  }
  managerCategoryTreeAvailable (data) {//下拉列表(商品分类)
		return this.getFn(newApj + '/api/manager/category/tree/available', data)
  }
  managerAddServiceList (data) {//列表查询(增值服务)
		return this.getFn(newApj + '/api/manager/add/service/list', data)
  }
  managerAddServiceSave (data) {//新增修改(增值服务)
		return this.postFn(newApj + '/api/manager/add/service/save', data)
  }
  managerAddServiceStatus (data) {//启用禁用(增值服务)
		return this.postFn(newApj + '/api/manager/add/service/status', data)
  }
  managerAddServiceDelete (data) {//删除(增值服务)
		return this.postFn(newApj + '/api/manager/add/service/delete', data)
  }
  managerAddServiceListAvailable (data) {//下拉列表(增值服务)
		return this.getFn(newApj + '/api/manager/add/service/list/available', data)
  }
  managerStockImport (data) {//导入盘库文件(库存分析)
		return this.postFn(newApj + '/api/manager/stock/import', data)
  }
  managerStockCheckList (data) {//列表查询(库存盘盈、盘亏单)
		return this.getFn(newApj + '/api/manager/stock/check/list', data)
  }
  managerStockCheckDetail (data) {//详情(库存盘盈、盘亏单)
		return this.getFn(newApj + '/api/manager/stock/check/detail', data)
  }
  managerStockCheckSave (data) {//新增修改(库存盘盈、盘亏单)
		return this.postFn(newApj + '/api/manager/stock/check/save', data)
  }
  managerStockCheckDelete (data) {//删除(库存盘盈、盘亏单)
		return this.postFn(newApj + '/api/manager/stock/check/delete', data)
  }
  managerStockCheckAudit (data) {//审核(库存盘盈、盘亏单)
		return this.postFn(newApj + '/api/manager/stock/check/audit', data)
  }
  managerStockCheckAuditEdit (data) {//反审核(库存盘盈、盘亏单)
		return this.postFn(newApj + '/api/manager/stock/check/audit/edit', data)
  }
  managerStockCheckRemark (data) {//备注(库存盘盈、盘亏单)
		return this.postFn(newApj + '/api/manager/stock/check/remark', data)
  }
  managerGoodsListImport1 (data) {//导入文件（适用范围：采购订单、采购入库单、零售退货入库单、库存盘盈单、库存盘亏单）(添加商品)
		return this.postFn(newApj + '/api/manager/goods/list/import1', data)
  }
  managerGoodsListImport2 (data) {//导入文件（适用范围：采购退货出库单、零售出库单、外部调拨单、内部转仓单）(添加商品)
		return this.postFn(newApj + '/api/manager/goods/list/import2', data)
  }
  managerGoodsList (data) {//列表查询(商品管理)
		return this.getFn(newApj + '/api/manager/goods/list', data)
  }
  managerGoodsDetail (data) {//总商品详情(商品管理)
		return this.getFn(newApj + '/api/manager/goods/detail', data)
  }
  managerGoodsItemList (data) {//商品列表(商品管理)
		return this.getFn(newApj + '/api/manager/goods/item/list', data)
  }
  managerGoodsSave (data) {//总商品新增修改(商品管理)
		return this.postFn(newApj + '/api/manager/goods/save', data)
  }
  managerGoodsItemSave (data) {//商品新增修改(商品管理)
		return this.postFn(newApj + '/api/manager/goods/item/save', data)
  }
  managerGoodsItemStatus (data) {//启用禁用(商品管理)
		return this.postFn(newApj + '/api/manager/goods/item/status', data)
  }
  managerGoodsItemShelf (data) {//上架下架(商品管理)
		return this.postFn(newApj + '/api/manager/goods/item/shelf', data)
  }
  managerGoodsItemDelete (data) {//删除(商品管理)
		return this.postFn(newApj + '/api/manager/goods/item/delete', data)
  }
  managerGoodsListSelect (data) {//聚合商品下拉列表(商品管理)
		return this.getFn(newApj + '/api/manager/goods/list/select', data)
  }
  managerGoodsMove (data) {//移动(商品管理)
		return this.postFn(newApj + '/api/manager/goods/move', data)
  }
  managerBannerList (data) {//列表查询(Banner管理)
		return this.getFn(newApj + '/api/manager/banner/list', data)
  }
  managerBannerSave (data) {//新增修改(Banner管理)
		return this.postFn(newApj + '/api/manager/banner/save', data)
  }
  managerBannerStatus (data) {//启用禁用(Banner管理)
		return this.postFn(newApj + '/api/manager/banner/status', data)
  }
  managerBannerDelete (data) {//删除(Banner管理)
		return this.postFn(newApj + '/api/manager/banner/delete', data)
  }
  managerReserveQuestionList (data) {//列表查询(预约问题)
		return this.getFn(newApj + '/api/manager/wx/reserve/question/list', data)
  }
  managerReserveQuestionSave (data) {//新增修改(预约问题)
		return this.postFn(newApj + '/api/manager/reserve/question/save', data)
  }
  managerReserveQuestionStatus (data) {//启用禁用(预约问题)
		return this.postFn(newApj + '/api/manager/reserve/question/status', data)
  }
  managerReserveQuestionDelete (data) {//删除(预约问题)
		return this.postFn(newApj + '/api/manager/reserve/question/delete', data)
  }
  managerReserveQuestionListAvailable (data) {//下拉列表(预约问题)
		return this.getFn(newApj + '/api/manager/reserve/question/list/available', data)
  }
  managerReserveSetList (data) {//列表查询(预约设置)
		return this.getFn(newApj + '/api/manager/reserve/set/list', data)
  }
  managerReserveSetSave (data) {//新增修改(预约设置)
		return this.postFn(newApj + '/api/manager/reserve/set/save', data)
  }
  managerReserveSetStatus (data) {//启用禁用(预约设置)
		return this.postFn(newApj + '/api/manager/reserve/set/status', data)
  }
  managerReserveSetDelete (data) {//删除(预约设置)
		return this.postFn(newApj + '/api/manager/reserve/set/delete', data)
  }
  managerSupplierList (data) {//列表查询(供应商)
		return this.getFn(newApj + '/api/manager/supplier/list', data)
  }
  managerSupplierSave (data) {//新增修改(供应商)
		return this.postFn(newApj + '/api/manager/supplier/save', data)
  }
  managerSupplierStatus (data) {//启用禁用(供应商)
		return this.postFn(newApj + '/api/manager/supplier/status', data)
  }
  managerSupplierDelete (data) {//删除(供应商)
		return this.postFn(newApj + '/api/manager/supplier/delete', data)
  }
  managerReserveSupplierDeleteAvailable (data) {//下拉列表(供应商)
		return this.getFn(newApj + '/api/manager/supplier/list/available', data)
  }
  managerMemberSetList (data) {//列表查询(会员设置)
		return this.getFn(newApj + '/api/manager/member/set/list', data)
  }
  managerMemberSetSave (data) {//新增修改(会员设置)
		return this.postFn(newApj + '/api/manager/member/set/save', data)
  }
  managerMemberSetStatus (data) {//启用禁用(会员设置)
		return this.postFn(newApj + '/api/manager/member/set/status', data)
  }
  managerMemberSetDelete (data) {//删除(会员设置)
		return this.postFn(newApj + '/api/manager/member/set/delete', data)
  }
  managerRoleList (data) {//列表查询(角色管理)
		return this.getFn(newApj + '/api/manager/role/list', data)
  }
  managerRoleSave (data) {//新增修改(角色管理)
		return this.postFn(newApj + '/api/manager/role/save', data)
  }
  managerRoleStatus (data) {//启用禁用(角色管理)
		return this.postFn(newApj + '/api/manager/role/status', data)
  }
  managerRoleDelete (data) {//删除(角色管理)
		return this.postFn(newApj + '/api/manager/role/delete', data)
  }
  managerRolePermission (data) {//权限设置(角色管理)
		return this.postFn(newApj + '/api/manager/role/permission', data)
  }
  managerRoleRoleListAvailable (data) {//下拉列表(角色管理)
		return this.getFn(newApj + '/api/manager/role/list/available', data)
  }
  managerUserManagerList (data) {//列表查询(用户管理)
		return this.getFn(newApj + '/api/manager/user/manager/list', data)
  }
  managerUserManagerSave (data) {//新增修改(用户管理)
		return this.postFn(newApj + '/api/manager/user/manager/save', data)
  }
  managerUserManagerStatus (data) {//启用禁用(用户管理)
		return this.postFn(newApj + '/api/manager/user/manager/status', data)
  }
  managerUserManagerDelete (data) {//删除(用户管理)
		return this.postFn(newApj + '/api/manager/user/manager/delete', data)
  }
  managerUserManagerResetPassoword(data) {//重置密码(用户管理)
		return this.postFn(newApj + '/api/manager/user/manager/reset/passoword', data)
  }
  managerUserManagerListAvailable (data) {//门店用户下拉列表(用户管理)
		return this.getFn(newApj + '/api/manager/user/manager/list/available', data)
  }
  managerUserManagerListAvailable2 (data) {//门店用户下拉列表(用户管理)
		return this.getFn(newApj + '/api/manager/user/manager/list/available2', data)
  }
  managerStockExchangeList (data) {//列表查询(内部转仓单)
		return this.getFn(newApj + '/api/manager/stock/exchange/list', data)
  }
  managerStockExchangeDetail (data) {//详情(内部转仓单)
		return this.getFn(newApj + '/api/manager/stock/exchange/detail', data)
  }
  managerStockExchangeSave (data) {//新增修改(内部转仓单)
		return this.postFn(newApj + '/api/manager/stock/exchange/save', data)
  }
  managerStockExchangeDelete (data) {//删除(内部转仓单)
		return this.postFn(newApj + '/api/manager/stock/exchange/delete', data)
  }
  managerStockExchangeAudit (data) {//审核(内部转仓单)
		return this.postFn(newApj + '/api/manager/stock/exchange/audit', data)
  }
  managerStockExchangeAuditEdit (data) {//反审核(内部转仓单)
		return this.postFn(newApj + '/api/manager/stock/exchange/audit/edit', data)
  }
  managerStockExchangeRemark (data) {//备注(内部转仓单)
		return this.postFn(newApj + '/api/manager/stock/exchange/remark', data)
  }
  managerPurchaseOrderList (data) {//列表查询(采购订单)
		return this.getFn(newApj + '/api/manager/purchase/order/list', data)
  }
  managerPurchaseOrderDetail (data) {//详情(采购订单)
		return this.getFn(newApj + '/api/manager/purchase/order/detail', data)
  }
  managerPurchaseOrderSave (data) {//新增修改(采购订单)
		return this.postFn(newApj + '/api/manager/purchase/order/save', data)
  }
  managerPurchaseOrderDelete (data) {//删除(采购订单)
		return this.postFn(newApj + '/api/manager/purchase/order/delete', data)
  }
  managerPurchaseOrderAudit (data) {//审核(采购订单)
		return this.postFn(newApj + '/api/manager/purchase/order/audit', data)
  }
  managerPurchaseOrderAuditEdit (data) {//反审核(采购订单)
		return this.postFn(newApj + '/api/manager/purchase/order/audit/edit', data)
  }
  managerPurchaseOrderRemark (data) {//备注(采购订单)
		return this.postFn(newApj + '/api/manager/purchase/order/remark', data)
  }
  managerPurchaseHouseInList (data) {//列表查询(采购入库单)
		return this.getFn(newApj + '/api/manager/purchase/house/in/list', data)
  }
  managerPurchaseHouseInDetail (data) {//详情(采购入库单)
		return this.getFn(newApj + '/api/manager/purchase/house/in/detail', data)
  }
  managerPurchaseHouseInSave (data) {//新增修改(采购入库单)
		return this.postFn(newApj + '/api/manager/purchase/house/in/save', data)
  }
  managerPurchaseHouseInDelete (data) {//删除(采购入库单)
		return this.postFn(newApj + '/api/manager/purchase/house/in/delete', data)
  }
  managerPurchaseHouseInAudit (data) {//审核(采购入库单)
		return this.postFn(newApj + '/api/manager/purchase/house/in/audit', data)
  }
  managerPurchaseHouseInAuditEdit (data) {//反审核(采购入库单)
		return this.postFn(newApj + '/api/manager/purchase/house/in/audit/edit', data)
  }
  managerPurchaseHouseInRemark (data) {//备注(采购入库单)
		return this.postFn(newApj + '/api/manager/purchase/house/in/remark', data)
  }
  managerPurchaseHouseOutList (data) {//列表查询(采购退货出库单)
		return this.getFn(newApj + '/api/manager/purchase/house/out/list', data)
  }
  managerPurchaseHouseOutDetail (data) {//详情(采购退货出库单)
		return this.getFn(newApj + '/api/manager/purchase/house/out/detail', data)
  }
  managerPurchaseHouseOutSave (data) {//新增修改(采购退货出库单)
		return this.postFn(newApj + '/api/manager/purchase/house/out/save', data)
  }
  managerPurchaseHouseOutDelete (data) {//删除(采购退货出库单)
		return this.postFn(newApj + '/api/manager/purchase/house/out/delete', data)
  }
  managerPurchaseHouseOutAudit (data) {//审核(采购退货出库单)
		return this.postFn(newApj + '/api/manager/purchase/house/out/audit', data)
  }
  managerPurchaseHouseOutAuditEdit (data) {//反审核(采购退货出库单)
		return this.postFn(newApj + '/api/manager/purchase/house/out/audit/edit', data)
  }
  managerPurchaseHouseOutRemark (data) {//备注(采购退货出库单)
		return this.postFn(newApj + '/api/manager/purchase/house/out/remark', data)
  }
  managerPurchaseReportList (data) {//列表查询(采购价异动报告)
		return this.getFn(newApj + '/api/manager/purchase/report/list', data)
  }
  managerRetailHouseOutList (data) {//列表查询(零售出库单)
		return this.getFn(newApj + '/api/manager/retail/house/out/list', data)
  }
  managerRetailHouseOutDetail (data) {//详情(零售出库单)
		return this.getFn(newApj + '/api/manager/retail/house/out/detail', data)
  }
  managerRetailHouseOutSave (data) {//新增修改(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/save', data)
  }
  managerRetailHouseOutDelete (data) {//删除(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/delete', data)
  }
  managerRetailHouseOutAudit (data) {//审核(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/audit', data)
  }
  managerRetailHouseOutAuditEdit (data) {//反审核(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/audit/edit', data)
  }
  managerRetailHouseOutTicket (data) {//上传小票(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/ticket', data)
  }
  managerRetailHouseOutRemark (data) {//备注(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/remark', data)
  }
  managerRetailHouseOutLinkList (data) {//下拉列表-最新的零售出库单(零售出库单)
		return this.getFn(newApj + '/api/manager/retail/house/out/link/list', data)
  }
  managerRetailHouseOutSignCreate (data) {//创建签名(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/sign/create', data)
  }
  managerRetailHouseOutSignSave (data) {//保存签名-Base64(零售出库单)
		return this.postFn(newApj + '/api/manager/retail/house/out/sign/save', data)
  }
  managerRetailHouseOutSignSavePhoto (data) {//保存签名
		return this.postFn(newApj + '/api/manager/retail/house/out/sign/save/photo', data)
  }
  managerRetailHouseOutSignSaveHtml (data) {//保存签名-HTML
		return this.postFn(newApj + '/api/manager/retail/house/out/sign/save/html', data)
  }
  managerBusinessListAvailable (data) {//下拉列表(业务子类别)
		return this.getFn(newApj + '/api/manager/business/list/available', data)
  }
  managerCouponUserAvailable (data) {//用户可用的优惠券(优惠券使用)
		return this.postFn(newApj + '/api/manager/coupon/user/available', data)
  }
  managerCouponUserAvailableV2 (data) {//用户可用的优惠券V2(优惠券使用)
		return this.postFn(newApj + '/api/manager/coupon/user/available/v2', data)
  }
  managerCouponUserCheck (data) {//优惠券是否可用和优惠券金额(优惠券使用)
		return this.postFn(newApj + '/api/manager/coupon/user/check', data)
  }
  managerUserQueryByPhone (data) {//下拉列表(查询会员信息)
		return this.getFn(newApj + '/api/manager/user/query/by/phone', data)
  }
  managerRetailHouseInList (data) {//列表查询(零售退货入库单)
		return this.getFn(newApj + '/api/manager/retail/house/in/list', data)
  }
  managerRetailHouseInDetail (data) {//详情(零售退货入库单)
		return this.getFn(newApj + '/api/manager/retail/house/in/detail', data)
  }
  managerRetailHouseInSave (data) {//新增修改(零售退货入库单)
		return this.postFn(newApj + '/api/manager/retail/house/in/save', data)
  }
  managerRetailHouseInDelete (data) {//删除(零售退货入库单)
		return this.postFn(newApj + '/api/manager/retail/house/in/delete', data)
  }
  managerRetailHouseInAudit (data) {//审核(零售退货入库单)
		return this.postFn(newApj + '/api/manager/retail/house/in/audit', data)
  }
  managerRetailHouseInAuditEdit (data) {//反审核(零售退货入库单)
		return this.postFn(newApj + '/api/manager/retail/house/in/audit/edit', data)
  }
  managerRetailHouseInRemark (data) {//备注(零售退货入库单)
		return this.postFn(newApj + '/api/manager/retail/house/in/remark', data)
  }
  managerStockExchangeOutsideList (data) {//列表查询(外部调拨单)
		return this.getFn(newApj + '/api/manager/stock/exchange/outside/list', data)
  }
  managerStockExchangeOutsideDetail (data) {//详情(外部调拨单)
		return this.getFn(newApj + '/api/manager/stock/exchange/outside/detail', data)
  }
  managerStockExchangeOutsideSave (data) {//新增修改(外部调拨单)
		return this.postFn(newApj + '/api/manager/stock/exchange/outside/save', data)
  }
  managerStockExchangeOutsideDelete (data) {//删除(外部调拨单)
		return this.postFn(newApj + '/api/manager/stock/exchange/outside/delete', data)
  }
  managerStockExchangeOutsideAudit (data) {//审核(外部调拨单)
		return this.postFn(newApj + '/api/manager/stock/exchange/outside/audit', data)
  }
  managerStockExchangeOutsideAuditEdit (data) {//反审核(外部调拨单)
		return this.postFn(newApj + '/api/manager/stock/exchange/outside/audit/edit', data)
  }
  managerStockExchangeOutsideConfirm (data) {//确认(外部调拨单)
		return this.postFn(newApj + '/api/manager/stock/exchange/outside/confirm', data)
  }
  managerStockExchangeOutsideRemark (data) {//备注(外部调拨单)
		return this.postFn(newApj + '/api/manager/stock/exchange/outside/remark', data)
  }
  managerSettlementList (data) {//列表查询(营业款日结单)
		return this.getFn(newApj + '/api/manager/settlement/list', data)
  }
  managerSettlementDetail (data) {//详情(营业款日结单)
		return this.getFn(newApj + '/api/manager/settlement/detail', data)
  }
  managerSettlementQueryAmount (data) {//查询营业额(营业款日结单)
		return this.getFn(newApj + '/api/manager/settlement/query/amount', data)
  }
  managerSettlementSave (data) {//新增修改(营业款日结单)
		return this.postFn(newApj + '/api/manager/settlement/save', data)
  }
  managerSettlementDelete (data) {//删除(营业款日结单)
		return this.postFn(newApj + '/api/manager/settlement/delete', data)
  }
  managerSettlementAudit (data) {//审核(营业款日结单)
		return this.postFn(newApj + '/api/manager/settlement/audit', data)
  }
  managerSettlementAuditEdit (data) {//反审核(营业款日结单)
		return this.postFn(newApj + '/api/manager/settlement/audit/edit', data)
  }
  managerSettlementRemark (data) {//备注(营业款日结单)
		return this.postFn(newApj + '/api/manager/settlement/remark', data)
  }
  managerSettlementCheckList1 (data) {//门店汇总(营业款对账单)
		return this.getFn(newApj + '/api/manager/settlement/check/list1', data)
  }
  managerSettlementCheckList2 (data) {//单据类别汇总(营业款对账单)
		return this.getFn(newApj + '/api/manager/settlement/check/list2', data)
  }
  managerSettlementCheckList3 (data) {//经手人汇总(营业款对账单)
		return this.getFn(newApj + '/api/manager/settlement/check/list3', data)
  }
  managerSettlementCheckList4 (data) {//制单人汇总(营业款对账单)
		return this.getFn(newApj + '/api/manager/settlement/check/list4', data)
  }
  managerSettlementCheckList5 (data) {//明细(营业款对账单)
		return this.getFn(newApj + '/api/manager/settlement/check/list5', data)
  }
  managerUserList (data) {//列表查询(会员管理)
		return this.getFn(newApj + '/api/manager/user/list', data)
  }
  managerUserDetailBase (data) {//基本信息(会员管理)
		return this.getFn(newApj + '/api/manager/user/detail/base', data)
  }
  managerUserDetailBaseSave (data) {//基本信息保存(会员管理)
		return this.postFn(newApj + '/api/manager/user/detail/base/save', data)
  }
  managerUserDetailBuy (data) {//消费记录(会员管理)
		return this.getFn(newApj + '/api/manager/user/detail/buy', data)
  }
  managerUserDetailCoupon (data) {//优惠券(会员管理)
		return this.getFn(newApj + '/api/manager/user/detail/coupon', data)
  }
  managerUserDetailMember (data) {//PLUS会员(会员管理)
		return this.getFn(newApj + '/api/manager/user/detail/member', data)
  }
  managerMemberSetListAvailable (data) {//会员类型下拉列表(会员管理)
		return this.getFn(newApj + '/api/manager/member/set/list/available', data)
  }
  managerUserDetailMemberSave (data) {//添加会员记录(会员管理)
		return this.postFn(newApj + '/api/manager/user/detail/member/save', data)
  }
  managerUserDetailCare (data) {//延保档案(会员管理)
		return this.getFn(newApj + '/api/manager/user/detail/care', data)
  }
  managerGoodsCareList (data) {//延保套餐(会员管理)
		return this.getFn(newApj + '/api/manager/goods/care/list', data)
  }
  managerUserDetailCareSave (data) {//添加延保档案(会员管理)
		return this.postFn(newApj + '/api/manager/user/detail/care/save', data)
  }
  managerAccountCheckList (data) {//列表查询(资金清缴明细)
		return this.getFn(newApj + '/api/manager/account/check/list', data)
  }
  managerAccountCheckSave (data) {//核销|批量核销(资金清缴明细)
		return this.postFn(newApj + '/api/manager/account/check/save', data)
  }
  managerReportPurchaseList (data) {//采购(进销存报表)
		return this.getFn(newApj + '/api/manager/report/purchase/list', data)
  }
  managerReportRetailList (data) {//销售-商品和增值服务(进销存报表)
		return this.getFn(newApj + '/api/manager/report/retail/list', data)
  }
  managerReportExchangeList (data) {//调拨(进销存报表)
		return this.getFn(newApj + '/api/manager/report/exchange/list', data)
  }
  managerReportCheckList (data) {//盘盈盘亏(进销存报表)
		return this.getFn(newApj + '/api/manager/report/check/list', data)
  }
  managerReportPayList (data) {//支付方式汇总(进销存报表)
		return this.getFn(newApj + '/api/manager/report/pay/list', data)
  }
  managerReportMemberList (data) {//会员(进销存报表)
		return this.getFn(newApj + '/api/manager/report/member/list', data)
  }
  managerReportStockList (data) {//库存(进销存报表)
		return this.getFn(newApj + '/api/manager/report/stock/list', data)
  }
  managerReportStockList2 (data) {//库存(进销存报表)
		return this.getFn(newApj + '/api/manager/report/stock/list2', data)
  }
  managerReportGoodsList (data) {//商品(进销存报表)
		return this.getFn(newApj + '/api/manager/report/goods/list', data)
  }
  managerReportProgressList (data) {//进度统计(进销存报表)
		return this.getFn(newApj + '/api/manager/report/progress/list', data)
  }
  managerCategoryServiceList (data) {//增值服务类别(列表查询)
		return this.getFn(newApj + '/api/manager/category/service/list', data)
  }
  managerCategoryServiceSave (data) {//增值服务类别(新增修改)
		return this.postFn(newApj + '/api/manager/category/service/save', data)
  }
  managerCategoryServiceStatus (data) {//增值服务类别(启用禁用)
		return this.postFn(newApj + '/api/manager/category/service/status', data)
  }
  managerCategoryServiceDelete (data) {//增值服务类别(删除)
		return this.postFn(newApj + '/api/manager/category/service/delete', data)
  }
  managerCategoryServiceListAvailable (data) {//增值服务类别(下拉列表)
		return this.getFn(newApj + '/api/manager/category/service/list/available', data)
  }
  managerCategoryStatisticsList (data) {//进度统计分类(列表查询)
		return this.getFn(newApj + '/api/manager/category/statistics/list', data)
  }
  managerCategoryStatisticsSave (data) {//进度统计分类(新增修改)
		return this.postFn(newApj + '/api/manager/category/statistics/save', data)
  }
  managerCategoryStatisticsStatus (data) {//进度统计分类(启用禁用)
		return this.postFn(newApj + '/api/manager/category/statistics/status', data)
  }
  managerCategoryStatisticsDelete (data) {//进度统计分类(删除)
		return this.postFn(newApj + '/api/manager/category/statistics/delete', data)
  }
  managerCategoryStatisticsListAvailable (data) {//进度统计分类(下拉列表)
		return this.getFn(newApj + '/api/manager/category/statistics/list/available', data)
  }
  managerNotPayCompanyList (data) {//挂账单位(列表查询)
		return this.getFn(newApj + '/api/manager/not/pay/company/list', data)
  }
  managerNotPayCompanySave (data) {//挂账单位(新增修改)
		return this.postFn(newApj + '/api/manager/not/pay/company/save', data)
  }
  managerNotPayCompanyStatus (data) {//挂账单位(启用禁用)
		return this.postFn(newApj + '/api/manager/not/pay/company/status', data)
  }
  managerNotPayCompanyDelete (data) {//挂账单位(删除)
		return this.postFn(newApj + '/api/manager/not/pay/company/delete', data)
  }
  managerNotPayCompanyListAvailable (data) {//挂账单位(下拉列表)
		return this.getFn(newApj + '/api/manager/not/pay/company/list/available', data)
  }
  managerNotPayCompanyListStoreAvailable (data) {//挂账单位(下拉列表（门店可选的）)
		return this.getFn(newApj + '/api/manager/not/pay/company/list/store/available', data)
  }
  photoUpload (data) {//图片上传
		return this.postFn(newApj + '/api/photo/upload', data)
  }
  managerHomeStatistics (data) {//首页统计
		return this.getFn(newApj + '/api/manager/home/statistics', data)
  }
  managerServiceSetList (data) {//（维修服务设置）列表
		return this.getFn(newApj + '/api/manager/service/set/list', data)
  }
  managerServiceSetDetail (data) {//（维修服务设置）详情
		return this.getFn(newApj + '/api/manager/service/set/detail', data)
  }
  managerServiceSetSave (data) {//（维修服务设置）修改
		return this.postFn(newApj + '/api/manager/service/set/save', data)
  }
  managerServiceSetStatus (data) {//（维修服务设置）启用禁用
		return this.postFn(newApj + '/api/manager/service/set/status', data)
  }
  managerRepairPriceLevel1 (data) {//（维修价格设置）服务类型下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/level1', data)
  }
  managerRepairPriceLevel2 (data) {//（维修价格设置）品牌或配件下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/level2', data)
  }
  managerRepairPriceLevel3 (data) {//（维修价格设置）机型下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/level3', data)
  }
  managerRepairPriceList (data) {//（维修价格设置）列表
		return this.getFn(newApj + '/api/manager/repair/price/list', data)
  }
  managerRepairPriceSave (data) {//（维修价格设置）新增修改
		return this.postFn(newApj + '/api/manager/repair/price/save', data)
  }
  managerRepairPriceDelete (data) {//（维修价格设置）删除
		return this.postFn(newApj + '/api/manager/repair/price/delete', data)
  }
  managerRepairPriceV2Level1 (data) {//（维修价格设置-V2）类别下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/v2/level1', data)
  }
  managerRepairPriceV2Level2 (data) {//（维修价格设置-V2）系列下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/v2/level2', data)
  }
  managerRepairPriceV2Level3 (data) {//（维修价格设置-V2）机型下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/v2/level3', data)
  }
  managerRepairPriceV2Level4 (data) {//（维修价格设置-V2）服务类别下拉列表
		return this.getFn(newApj + '/api/manager/repair/price/v2/level4', data)
  }
  managerRepairPriceV2List (data) {//（维修价格设置-V2）列表
		return this.getFn(newApj + '/api/manager/repair/price/v2/list', data)
  }
  managerRepairPriceV2Save (data) {//（维修价格设置-V2）新增修改
		return this.postFn(newApj + '/api/manager/repair/price/v2/save', data)
  }
  managerRepairPriceV2Delete (data) {//（维修价格设置-V2）删除
		return this.postFn(newApj + '/api/manager/repair/price/v2/delete', data)
  }
  managerOtherProductList (data) {//（其它商品设置）列表
		return this.getFn(newApj + '/api/manager/other/product/list', data)
  }
  managerOtherProductSave (data) {//（其它商品设置）修改
		return this.postFn(newApj + '/api/manager/other/product/save', data)
  }
  frontWxOrderStaffList (data) {//（我的订单）（管理端）订单列表
		return this.getFn(newApj + '/api/front/wxOrder/staff/list', data)
  }
  frontWxOrderStaffDetail(data) {//（我的订单）（管理端）订单详情
    return this.getFn(newApj + '/api/front/wxOrder/staff/detail', data)
  }
  frontWxOrderStaffConfirmLeftPay(data) {//（我的订单）（管理端）确认支付尾款
    return this.postFn(newApj + '/api/front/wxOrder/staff/confirm/left/pay', data)
  }
  frontWxOrderStaffExpress(data) {//（我的订单）（管理端）发货
    return this.postFn(newApj + '/api/front/wxOrder/staff/express', data)
  }
  frontRetailHouseOutStaffLinkList (data) {//(管理端）可选的零售出库单(管理端)关联零售出库单)
		return this.getFn(newApj + '/api/front/retail/house/out/staff/link/list', data)
  }
  frontRetailHouseOutStaffLinkSave (data) {//（管理端）关联零售出库单(管理端)关联零售出库单)
		return this.postFn(newApj + '/api/front/retail/house/out/staff/link/save', data)
  }
  frontWxReserveStoreStaffList(data) {//（预约到店）（管理端）列表
    return this.getFn(newApj + '/api/front/wxReserveStore/staff/list', data)
  }
  frontWxReserveStoreStaffSign(data) {//（预约到店）（管理端）到店签到
    return this.postFn(newApj + '/api/front/wxReserveStore/staff/sign', data)
  }
  frontWxReservePostStaffList(data) {//（邮寄送修）（管理端）列表
    return this.getFn(newApj + '/api/front/wxReservePost/staff/list', data)
  }
  frontWxReservePostStaffConfirmSend(data) {//（邮寄送修）（管理端）邮寄审核
    return this.postFn(newApj + '/api/front/wxReservePost/staff/confirm/send', data)
  }
  frontWxReservePostStaffConfirmReceipt(data) {//（邮寄送修）（管理端）寄出确认收货
    return this.postFn(newApj + '/api/front/wxReservePost/staff/confirm/receipt', data)
  }
  frontWxReservePostStaffReturnSend(data) {//（邮寄送修）（管理端）寄回
    return this.postFn(newApj + '/api/front/wxReservePost/staff/return/send', data)
  }
  frontWxReservePostStaffCancel(data) {//（邮寄送修）（管理端）取消-待邮寄|已邮寄状态才可取消
    return this.postFn(newApj + '/api/front/wxReservePost/staff/cancel', data)
  }
  frontWxReservePostStaffRemark2(data) {//（邮寄送修）（管理端）确认收货后备注
    return this.postFn(newApj + '/api/front/wxReservePost/staff/remark2', data)
  }
  managerShareOrderList(data) {//（分享记录）（管理端）列表
    return this.getFn(newApj + '/api/manager/share/order/list', data)
  }
  managerOptLogList(data) {//（管理端）日志
    return this.getFn(newApj + '/api/manager/opt/log/list', data)
  }
  frontWxReservePostUserCancel(data) {//（邮寄送修）（用户端）取消
    return this.postFn(newApj + '/api/front/wxReservePost/user/cancel', data)
  }
  managerStoreListAvailable(data) {//（下拉列表数据）门店列表
    return this.getFn(newApj + '/api/manager/store/list/available', data)
  }
  frontWxOldNewStaffList(data) {//(以旧换新)（管理端）列表
    return this.getFn(newApj + '/api/front/wxOldNew/staff/list', data)
  }
  frontWxOldNewStaffFirstPrice(data) {//(以旧换新)（管理端）首次报价
    return this.postFn(newApj + '/api/front/wxOldNew/staff/first/price', data)
  }
  frontWxOldNewStaffFinalPrice(data) {//(以旧换新)（管理端）最终报价
    return this.postFn(newApj + '/api/front/wxOldNew/staff/final/price', data)
  }
  managerUserShopSave(data) {//标记商家
    return this.postFn(newApj + '/api/manager/user/shop/save', data)
  }
  managerUserShopList(data) {//商家下拉列表
    return this.getFn(newApj + '/api/manager/user/shop/list', data)
  }
  managerUserDelete(data) {//删除用户
    return this.postFn(newApj + '/api/manager/user/delete', data)
  }
  managerDictTypeList(data) {//数据字典(字典类别)
    return this.getFn(newApj + '/api/manager/dict/type/list', data)
  }
  managerDictList(data) {//数据字典(字典列表)
    return this.getFn(newApj + '/api/manager/dict/list', data)
  }
  managerDictSave(data) {//数据字典(新增修改)
    return this.postFn(newApj + '/api/manager/dict/save', data)
  }
  managerDictDelete(data) {//数据字典(删除)
    return this.postFn(newApj + '/api/manager/dict/delete', data)
  }
  managerSysParamList(data) {//系统参数(字典列表)
    return this.getFn(newApj + '/api/manager/sys/param/list', data)
  }
  managerSysParamSave(data) {//系统参数(修改)
    return this.postFn(newApj + '/api/manager/sys/param/save', data)
  }
  managerReportRecoveryList(data) {//回收统计
    return this.getFn(newApj + '/api/manager/report/recovery/list', data)
  }
  managerRecoveryCheckList(data) {//回收款核销(列表查询)
    return this.getFn(newApj + '/api/manager/recovery/check/list', data)
  }
  managerRecoveryCheckSave(data) {//回收款核销(核销)
    return this.postFn(newApj + '/api/manager/recovery/check/save', data)
  }
  managerRecoveryList(data) {//列表查询(旧机回收)
    return this.getFn(newApj + '/api/manager/recovery/list', data)
  }
  managerRecoveryDetail(data) {//详情(旧机回收)
    return this.getFn(newApj + '/api/manager/recovery/detail', data)
  }
  managerRecoverySave(data) {//新增修改(旧机回收)
    return this.postFn(newApj + '/api/manager/recovery/save', data)
  }
  managerRecoveryDelete(data) {//删除(旧机回收)
    return this.postFn(newApj + '/api/manager/recovery/delete', data)
  }
  managerRecoveryAudit(data) {//审核(旧机回收)
    return this.postFn(newApj + '/api/manager/recovery/audit', data)
  }
  managerRecoveryAuditEdit(data) {//反审核(旧机回收)
    return this.postFn(newApj + '/api/manager/recovery/audit/edit', data)
  }
  managerRetailHouseOutListItem (data) {//（管理端）通过关联单号查询商品
		return this.getFn(newApj + '/api/manager/retail/house/out/list/item', data)
  }
  managerWxOpenidLogList (data) {//（管理端）微信ID查询
		return this.getFn(newApj + '/api/manager/wx/openid/log/list', data)
  }
  timeCurrent (data) {//（管理端）微信ID查询
		return this.getFn(newApj + '/api/time/current', data)
  }
  frontWxOrderStaffDeliveryDay (data) {//（管理端）邮寄|自提日期
		return this.postFn(newApj + '/api/front/wxOrder/staff/delivery/day', data)
  }
  managerQywxSendSetList(data) {//推送设置(字典列表)
    return this.getFn(newApj + '/api/manager/qywx/send/set/list', data)
  }
  managerQywxSendSetSave(data) {//推送设置(新增修改)
    return this.postFn(newApj + '/api/manager/qywx/send/set/save', data)
  }
  managerQywxSendSetDelete(data) {//推送设置(删除)
    return this.postFn(newApj + '/api/manager/qywx/send/set/delete', data)
  }
  htmlToImage(data) {
    return this.postFn(newApj + '/api/html/to/image', data)
  }
  

	postFn (url,data) {
    return Vue.http.post(url, data,{
      headers: {
        "Authorization": state.token
      },
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      Cookies.set('SHANGYI_TOKEN', '')
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      _this.$alert(data.body.msg, {
          confirmButtonText: '确定',
          showClose: false
        });
    }
    return data
    }).catch((err) => {
    state.loading =  false;
    })
  }
  getFn (url,data) {
    return Vue.http.get(url, {
      params: data,
      headers: { "Authorization": state.token }
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      Cookies.set('SHANGYI_TOKEN', '')
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      _this.$alert(data.body.msg, {
          confirmButtonText: '确定',
          showClose: false
        });
    }
    return data
    }).catch((err) => {
    state.loading =  false;
    })
  }
}

export default new BaseModule()



// WEBPACK FOOTER //
// ./src/api/index.js